import type { ColumnDef } from "@tanstack/react-table";

import { formatDate, numberWithSpaces } from "@/shared/lib/utils";
import { DataTableCenteredCell } from "@/shared/ui/DataTable";

import { ConfirmRemoveModal } from "./ConfirmRemoveModal";
import {
  type Mentorship,
  MentorshipStatus,
  MentorshipType,
} from "@/entities/mentorship";

export const MentorshipsColumns: ColumnDef<Mentorship>[] = [
  {
    accessorKey: "student",
    header: "Логин",
    cell: ({ row }) => row.original.student.username,
  },
  {
    accessorKey: "status",
    header: () => <DataTableCenteredCell>Статус</DataTableCenteredCell>,
    cell: ({ row }) => (
      <DataTableCenteredCell>
        {row.original.status === MentorshipStatus.ACTIVE
          ? "Активный"
          : "Выпустился"}
      </DataTableCenteredCell>
    ),
  },
  {
    accessorKey: "createdAt",
    header: () => <DataTableCenteredCell>Дата привязки</DataTableCenteredCell>,
    cell: ({ row }) => (
      <DataTableCenteredCell>
        {row.original.updatedAt ? formatDate(row.original.createdAt) : "N/A"}
      </DataTableCenteredCell>
    ),
  },
  {
    accessorKey: "grossIncome",
    header: () => <DataTableCenteredCell>До отвязки</DataTableCenteredCell>,
    cell: ({ row }) => {
      const earnings = Math.max(
        0,
        Math.min(10000 - row.original.grossIncome, 10000),
      );

      const formattedEarnings =
        typeof earnings === "number" ? numberWithSpaces(earnings) : "N/A";

      return (
        <DataTableCenteredCell>
          {row.original.type === MentorshipType.AUTO
            ? row.original.status === MentorshipStatus.ACTIVE
              ? "$" + formattedEarnings
              : "N/A"
            : "N/A"}
        </DataTableCenteredCell>
      );
    },
  },
  {
    accessorKey: "actions",
    header: "Отвязать",
    cell: ({ row }) => (
      <DataTableCenteredCell>
        <ConfirmRemoveModal
          id={row.original._id}
          username={row.original.student.username}
        />
      </DataTableCenteredCell>
    ),
  },
];
